import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerPrimaNotaModalComponent } from './worker-prima-nota-modal';

export const WorkerPrimaNotaModalModule: string = ng
    .module('worker-prima-nota-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerPrimaNotaModalComponent', WorkerPrimaNotaModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-prima-nota-modal/worker-prima-nota-modal.module.ts